import { STORAGE_LIKES } from "@components/utils/constants";
import RaQFormContentWrapper from "@modules/requestAQuote/components/RaQFormContentWrapper";
import { ITag } from "@modules/requestAQuote/components/TripPreferences";
import TripPreferencesDetailSection from "@modules/requestAQuote/components/TripPreferencesDetailSection";

interface IProps {
  accommodationTags: ITag[];
  autoPlacesTags: ITag[];
  importantTags: ITag[];
  locations: ITag[];
  handleRemoveTag: (tagData: string, tagType: string) => void;
}

const TripPreferences = ({
  accommodationTags,
  autoPlacesTags,
  importantTags,
  locations,
  handleRemoveTag,
}: IProps): JSX.Element => {
  const sectionOneTags = importantTags.filter((tag) => tag.type === "Tag");

  const sectionTwoTags = [
    ...locations,
    ...importantTags.filter((tag) => tag.type === "Location Type"),
  ];

  return (
    <RaQFormContentWrapper>
      <TripPreferencesDetailSection
        key="section1"
        title="What’s The Occasion?"
        tags={sectionOneTags}
        handleRemoveTag={handleRemoveTag}
      />
      <TripPreferencesDetailSection
        key="section2"
        title="Places you want to Visit"
        tags={sectionTwoTags}
        handleRemoveTag={handleRemoveTag}
      />
      <TripPreferencesDetailSection
        key="section3"
        title="Where To Stay"
        tags={accommodationTags}
        handleRemoveTag={handleRemoveTag}
        RaQSection={STORAGE_LIKES.accommodations}
      />
      <TripPreferencesDetailSection
        key="section4"
        title="Things To Do"
        tags={autoPlacesTags}
        handleRemoveTag={handleRemoveTag}
        RaQSection={STORAGE_LIKES.activities}
      />
    </RaQFormContentWrapper>
  );
};

export default TripPreferences;
